
function pollForElement(elementId, attributeNames, interval = 1000, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        const poll = setInterval(() => {
            const element = document.getElementById(elementId);

            console.log('polling for element', elementId);
            
            // If element is found, clear the interval and copy attributes
            if (element) {
                clearInterval(poll);

                const attributes = {};
                attributeNames.forEach(attr => {
                    attributes[attr] = element.getAttribute(attr);
                });

                resolve(attributes); // Return the attributes
            }

            // If the timeout is reached, stop polling
            if (Date.now() - startTime >= timeout) {
                clearInterval(poll);
            }
        }, interval);
    });
}


window.SetupBrowseAloudRemote = function () {
    
    var _baFooter = document.getElementById('browsealoud-button--launchpad_shadow');

    if (_baFooter) {

        // look for the BrowseAloud button elsewhere on the page
        // and copy the attributes to the 2nd button in the site footer
        pollForElement('browsealoud-button--launchpad', ['aria-label', 'title', 'class'], 500, 15000)
            .then(attributes => {

                var _baMasthead = document.getElementById('browsealoud-button--launchpad');
                
                if (_baMasthead) {
                    _baFooter.addEventListener('click', function () {
                        window.toggleBar();
                    });

                    _baFooter.setAttribute('aria-label', attributes['aria-label']);
                    _baFooter.setAttribute('title', attributes['title']);
                    _baFooter.setAttribute('class', attributes['class']);
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
	
}

if (document.readyState !== 'loading') {
	window.SetupBrowseAloudRemote();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetupBrowseAloudRemote();
	});
}